import { Component, Input } from '@angular/core';

@Component({
    selector: 'fcp-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.less'],
    standalone: false
})
export class EmptyStateComponent {
    @Input() imageSrc: string;
    @Input() header: string;
    constructor() {}
}
